// extracted by mini-css-extract-plugin
module.exports = {"filter":"UserSideBarFilter_filter__1V1fe","wrap":"UserSideBarFilter_wrap__S4eQV"};